/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_CombineInputs */

const en_pc_cmp_r_combine = /** @type {(inputs: Pc_Cmp_R_CombineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine, extract and split`)
};

const zh_pc_cmp_r_combine = /** @type {(inputs: Pc_Cmp_R_CombineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并、提取与拆分`)
};

/**
* | output |
* | --- |
* | "Combine, extract and split" |
*
* @param {Pc_Cmp_R_CombineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_combine = /** @type {((inputs?: Pc_Cmp_R_CombineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_CombineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_combine(inputs)
	return zh_pc_cmp_r_combine(inputs)
});
export { pc_cmp_r_combine as "pc.cmp.r.combine" }